const required = value => (value ? undefined : 'required')

const minLength = min => value =>
	value && value.length < min ? `minLength${min}` : undefined

const minLength6 = minLength(6)

const email = value =>
	value && !/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(value)
		? 'invalid_email_address'
		: undefined

export { required, minLength6, email }
